import React, { useEffect, useState } from 'react';
import { Container, Grow, Grid, createTheme, ThemeProvider, Stack, useMediaQuery } from '@mui/material';
import Form from './components/Form/Form';
import Posts from './components/Posts/Posts';
import { StyledAppBar, StyledTypography } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { getPosts } from './actions/posts';
import HiveIcon from '@mui/icons-material/Hive';
import PatternRoundedIcon from '@mui/icons-material/PatternRounded';
import { pink, white } from '@mui/material/colors';
import './root.scss';
import NavBar from './components/NavBar/NavBar';
import { BrowserRouter, Routes, Route, Navigate, useLocation} from 'react-router-dom'; 
import Home from './components/Home/Home';
import Auth from './components/Auth/Auth';
import theme from './muiTheme';
import {GoogleOAuthProvider} from '@react-oauth/google'; 
import PostDetails from './components/PostDetails/PostDetails';
import FloatingOptions from './components/FloatingOptions/FloatingOptions';
import ScrollToTop from './hooks/scrollToTop';
import EditProfile from './components/Accounts/EditProfile/EditProfile';
import { rePopulate } from './actions/auth';
import ProfilePage from './components/ProfilePage/ProfilePage';
import { closeSocket, createSocket } from './actions/sockets';
import { fetchHistoricNotifications } from './actions/notifications';
import PopUpNotifications from './components/PopUpNotifications/PopUpNotifications';
import Notifications from './components/Notifications/Notifications';
import DynamicUI from './components/DynamicUI/DynamicUI';
import ChatUI from './components/ChatUI/ChatUI';
import { getChats } from './actions/chat';

/* 
    Although environment variables are baked into the React build,
    it's still a cleaner way of storing things like google client id which don't need to be secrets
    but would rather not be shared on github
*/

const App = () => {

    const authStateSlice = useSelector((state) => state.authReducer);
    const socketStateSlice = useSelector((state) => state.socketsReducer);
    const [socketCreated, setSocketCreated] = useState(false);
    const [showForm, setShowForm] = useState(false); 
    const dispatch = useDispatch(); 
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem('profile')));
    const isMobile = useMediaQuery('(max-width: 768px)'); //TODO - Move this to a global state value instead of querying it in every component!!!!!

    // useEffect(()=>{
    //     //get auth data from localStorage
        

    //     if(profile){

    //         //dispatch action to update authState
    //         console.log('APP.js profile: ', profile);

    //         dispatch(rePopulate(profile));
    //     }
        
    // }, []);

    useEffect(()=>{

        if(authStateSlice?.authData?.result){

            console.log('auth state changed, fetching chats and historic data');

            //get unread notifications that took place while user was away
            dispatch(fetchHistoricNotifications(authStateSlice?.authData?.result._id));

            //get chats
            dispatch(getChats(authStateSlice?.authData?.result._id, 1));
        }

    }, [authStateSlice?.authData]);

    useEffect(()=> {

        //create new socket


        if(!socketCreated && authStateSlice?.authData?.result){

            console.log('creating NEW SOCKET!');

            dispatch(createSocket({
                name: 'main',
                onConnect: (socket) => {
                    console.log('Socket: On connect invoked, authStateSlice.authData: ', authStateSlice.authData);
                    //handshake with server
                    if(authStateSlice.authData){
                        console.log('Socket: about to handshake');
                        socket.emit('handshake', { 
                            name: authStateSlice.authData.result.name, 
                            id: authStateSlice.authData.result._id,
                            chatRooms: authStateSlice.authData.result.chatRooms || []
                        });
                    }
                }
            })); 

            setSocketCreated(true);
        }
        

    

        return () => {
            //destroy socket

            console.log('socket being destroyed');
            dispatch(closeSocket('main'));
        }

    }, [authStateSlice?.authData]);

    const updateAuth = ()=>{

        //check if user is logged in on every path change
        const localStorageProfile = JSON.parse(localStorage.getItem('profile')); 
        setProfile(localStorageProfile);

    };

    console.log('user: ', authStateSlice);

    return (

        <GoogleOAuthProvider clientId={`${process.env.REACT_APP_G_Client_ID}`}>

            <ThemeProvider theme={theme}>
        
                <BrowserRouter>
                    <ScrollToTop />
                    <Container variant="fullbleed" maxWidth={false}>
                        <NavBar updateAuth={updateAuth}/>
                        <FloatingOptions style={{position: 'absolute'}} setShowForm={setShowForm} showForm={showForm}/>

                        <Routes>
                            <Route path='/'> 
                                <Route index element={<Navigate to='/posts' />} />
                                <Route path='auth' element={profile ? <Navigate to='/posts' /> : <Auth /> } />
                                <Route path='profile' element={<ProfilePage /> } /> 
                                <Route path='profile/:id' element={<ProfilePage /> } /> 
                                <Route path='profile/edit' element={profile ? <EditProfile /> : <Navigate to='/posts' /> } /> 
                                <Route path='posts' exact element={<Home setShowForm={setShowForm} showForm={showForm} />} />
                                <Route path='posts/search' exact element={<Home setShowForm={setShowForm} showForm={showForm} />} />
                                <Route path='posts/:id' exact element={isMobile ? <PostDetails /> : <Home setShowForm={setShowForm} showForm={showForm} />} />
                                
                            </Route>
                            
                        </Routes>

                        <DynamicUI />
                        <PopUpNotifications />
                        <ChatUI />
                        
                    </Container>
                </BrowserRouter>
                
            </ThemeProvider>
        </GoogleOAuthProvider>
        
    );
}

export default App; 